import { useStarterContext } from '@/context/StarterContext';
import { WelcomeScreen } from '@/components/onboarding/WelcomeScreen';
import { DashboardPage } from '@/components/dashboard/DashboardPage';
import { Skeleton } from '@/components/ui/Skeleton';
import { Card } from '@/components/ui/Card';

export function HomeView() {
  const { starter, isLoading } = useStarterContext();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-lg)', padding: 'var(--spacing-md) 0' }}>
        <Card>
          <Skeleton variant="rectangular" height={120} />
        </Card>
        <Skeleton variant="rectangular" height={56} />
        <Card>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-sm)' }}>
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
          </div>
        </Card>
      </div>
    );
  }

  if (!starter) {
    return <WelcomeScreen />;
  }

  return <DashboardPage />;
}
